import validate from 'validate.js'
const constraints = {
    country: {
	presence: true
    },
    name: {
	presence: true,
	length: { message: {code: 'minlength', minimum: 3 }, minimum: 3 }
    }
}

export default fields =>  validate(fields, constraints, {fullMessages: false}) || {}
